import * as Yup from "yup";
import "yup-phone";

export const ExportAdminCsvSchema = Yup.object({
  uploadDateFrom: Yup.date().required("Upload date from is required"),
  uploadDateTo: Yup.date().required("Upload date to is required"),
  // email: Yup.string().email("Email is not valid").required("Email cannot be blank"),
});

export const ExportCsvSchema = Yup.object({
  email: Yup.string().email("Email is not valid").required("Email cannot be blank"),
});